export default __webpack_public_path__ + "static/media/grapes.2ccce626.jpg";